var styles = {"fontElementMap":"_6PlQZ","orderedlist":"bu-Wp","bulletedlist":"dIfcd","listItem":"_3TiTE"};

export { styles as s };
//# sourceMappingURL=lists-6a43fa59.js.map
